import debugConstructor from 'debug'

export const USERCENTRICS_HOTJAR_NAME = 'Hotjar'
export const DEFAULT_SV = 6

export const DEBUG = debugConstructor('hotjar')
